<template>
    <div class="main_page_slider" ref="main_page_slider_ref">
        <div class="main-page-swiper-container">
            <div ref="img" class="swiper-wrapper">
                <div ref="img1" class="swiper-slide img" v-for="obj in dataSlides" :style="{'background-image': 'url(' + obj.img_url + ')', 'background-position-y': obj.img_pos_y+'px'}">
                    <div class="title-des" ref="title_des_ref">
                        <router-link :to="obj.page_url ? obj.page_url : ''">
                            <h3 class="title" data-swiper-parallax="-150">{{ obj.title }}</h3>
                        </router-link>
                        <p class="description" data-swiper-parallax="-200">{{ obj.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>
    
<script>

import Swiper from '@/shared/lib/third-parties/swiper.js'
import { isMobileG } from '@/shared/lib/helpers.js'

export default {
    props:{
        isSearchText:{
            type: String
        }
    },
    watch:{
        isSearchText(){
            
            if(this.isSearchText){
                this.minimizeSlider();
                console.log("LOL " + this.isSearchText)
            }else{
                this.normalizeSlider();
                console.log("LOL " + this.isSearchText)
            }
        }
    },
    data() {
        return {
            dataSlides: [
                {
                    title: '100 девушек',
                    description: 'Школьник Рэнтаро Аидзё обладает приятной внешностью, занимается спортом и популярен среди сверстников...(обязательно смотреть в DreamCast).',
                    page_url: '/54714',
                    img_url: 'https://imgos.info/upload/anime/images/6523bf077048e135183359.jpg',
                    img_pos_y: 0
                },
                {
                    title: 'Летний призрак',
                    description: 'Городская легенда гласит, что во время фейерверков появляется летний призрак.',
                    page_url: '/48171',
                    img_url: require("@/assets/images/1737191754752.jpg"),
                    img_pos_y: -40
                },
                {
                    title: 'Межсезонье и сезон монстров',
                    description: 'Это прекрасно — время от времени спасать девушек, которые не имеют к тебе никакого отношения...',
                    page_url: '/57864',
                    img_url: 'https://www.todofondos.net/wp-content/uploads/2560x1600-Serie-Monogatari-All-HD-Wallpaper-Descargar.jpg',
                    img_pos_y: -60
                }
            ],
        };
    },
    mounted() {
        this.initSwiper();
    },
    methods: {
        showData() {
            // console.log(this.$refs.img.style.backgroundImage = 'url(https://shikimori.one/system/screenshots/original/c696084e685842b0525c74ace4675c3858041dd9.jpg?1663078902)');
            this.$refs.img1.style.backgroundImage = `
            url(https://p.sda1.dev/7/1ac3cd07273b821a088a62a5cfb9b3b5/20220930_010809.jpg)`;
            this.$refs.img2.style.backgroundImage = 'url(https://static.okko.tv/images/v3/21394214)';
            this.$refs.img3.style.backgroundImage = `url(
                https://files.vgtimes.ru/posts/2023-01/1672948499_marin.jpg
            )`;
            // this.$refs.img.style.backgroundPositionX = '50%';
            // this.$refs.img.style.backgroundSize = 'cover';
        },
        minimizeSlider(){
            if(isMobileG()){
                this.$refs.main_page_slider_ref.style.height = '350px';
                // console.log(document.querySelector('.anime-swipers').style.marginTop = '110px');
            }else{
                this.$refs.main_page_slider_ref.style.height = '247px';
                document.querySelector('.anime-swipers').style.marginTop = '110px';
            }
        },
        normalizeSlider(){
            if(isMobileG()){
                this.$refs.main_page_slider_ref.style.height = '350px';
                document.querySelector('.anime-swipers').style.marginTop = '170px';
            }else{
                this.$refs.main_page_slider_ref.style.height = '500px';
                document.querySelector('.anime-swipers').style.marginTop = '350px';
            }
            
        },
        initSwiper() {
            setTimeout(function () {
                new Swiper('.main-page-swiper-container', {
                    slidesPerView: "auto",
                    direction: "horizontal",
                    touchRatio: 1.0,
                    grabCursor: true,
                    loop: true,
                    parallax:true,
                    effect: "creative",
                    creativeEffect: {
                        prev: {
                            shadow: true,
                            translate: [0, 0, -400],
                        },
                        next: {
                            translate: ["100%", 0, 0],
                        },
                    },
                    autoplay: { delay: 10000, disableOnInteraction: false, reverseDirection: true,}
                });
            }, 20);
        }
    }
};
</script>

<style scoped>
.main_page_slider{
    position: absolute;
    top: 0;
    width: 100%;
    height: 500px;
}

.main_page_slider .main-page-swiper-container{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
}
.main_page_slider .img{
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position-x: center;
    /* background-repeat: no-repeat; */
    box-shadow: 0px -117px 103px -21px rgb(0 0 0) inset;
    border-bottom-left-radius: 23px;
    border-bottom-right-radius: 23px;
    border-bottom: 2px solid white;
}

.main_page_slider .title-des .title{
    font-family: 'Montserrat', sans-serif;
    cursor: pointer;
    transition: .3s;
    font-size: 32px;
    margin-bottom: 0;
}


.title-des .description {
  font-size: 1.1rem;
  line-height: 1.5;
}

.main_page_slider .title-des .title:hover{
    color: rgb(57, 136, 255)
}

.main_page_slider .title-des .description{
    margin-top: 5px;
}
.main_page_slider .title-des{
    position: absolute;
    left: 30px;
    bottom: 15px;
}

.main_page_slider .title-des a{
    display: inline-block;
}



@media only screen and (max-width: 600px) {
    .main_page_slider{
        height: 350px;
    }

    .main_page_slider .title-des .title{
        font-size: 25px;
    }

    .main_page_slider .title-des .description{
        /* display: none; */
    }

    .main_page_slider .img{
        width: 100%;
        height: 100%;
        background-size: cover;
    }

    .main_page_slider .img{
        border-bottom: none;
    }
}
</style>